export const umeEndpoints = {
    configuration: {
        list: {
            api: '/ume-configurations',
            method: 'GET',
            parameter: false
        },
        details: {
            api: '/ume-configurations/details',
            method: 'GET',
            parameter: true
        },
        add: {
            api: '/ume-configurations',
            method: 'POST',
            parameter: false
        },
        edit: {
            api: '/ume-configurations/update',
            method: 'POST',
            parameter: false
        },
        delete: {
            api: '/ume-configurations/delete',
            method: 'POST',
            parameter: false
        },
        toggleStatus: {
            api: '/ume-configurations/togglestatus',
            method: 'POST',
            parameter: true
        }
    },
    user: {
        list: {
            api: '/users',
            method: 'GET',
            parameter: false
        },
        details: {
            api: '/users/',
            method: 'GET',
            parameter: true
        },
        add: {
            api: '/users',
            method: 'POST',
            parameter: false
        },
        edit: {
            api: '/users/',
            method: 'POST',
            parameter: true
        },
        delete: {
            api: '/users/delete/',
            method: 'POST',
            parameter: true
        },
        toggleStatus: {
            api: '/users/togglestatus/',
            method: 'POST',
            parameter: true
        }
    },
    group: {
        list: {
            api: '/groups',
            method: 'GET',
            parameter: false
        },
        details: {
            api: '/groups/',
            method: 'GET',
            parameter: true
        },
        add: {
            api: '/groups',
            method: 'POST',
            parameter: false
        },
        edit: {
            api: '/groups/',
            method: 'POST',
            parameter: true
        },
        delete: {
            api: '/groups/delete/',
            method: 'POST',
            parameter: true
        },
        toggleStatus: {
            api: '/groups/togglestatus/',
            method: 'POST',
            parameter: true
        }
    },
    domain: {
        list: {
            api: '/domains',
            method: 'GET',
            parameter: false
        },
        details: {
            api: '/domains/',
            method: 'GET',
            parameter: true
        },
        add: {
            api: '/domains',
            method: 'POST',
            parameter: false
        },
        edit: {
            api: '/domains/',
            method: 'POST',
            parameter: true
        },
        delete: {
            api: '/domains/delete/',
            method: 'POST',
            parameter: true
        }
    },
    policy: {
        list: {
            api: '/policies',
            method: 'GET',
            parameter: false
        },
        details: {
            api: '/policies/',
            method: 'GET',
            parameter: true
        },
        add: {
            api: '/policies',
            method: 'POST',
            parameter: false
        },
        edit: {
            api: '/policies/',
            method: 'POST',
            parameter: true
        },
        delete: {
            api: '/policies/delete/',
            method: 'POST',
            parameter: true
        },
        exportData:{
            api: '/policies/export/',
            method: 'GET',
            parameter: true
        }
    },
    profile: {
        details: {
            api: '/profile',
            method: 'GET',
            parameter: false
        },
        edit: {
            api: '/profile',
            method: 'POST',
            parameter: false
        },
    },
    dictionary: {
        configurationType: {
            api: '/ume-configurations/configurations/dictionary',
            method: 'GET',
            parameter: false
        },
        listPolicyAPIs: {
            api: '/policies/apilist',
            method: 'GET',
            parameter: false
        },
        notificationGroups: {
            api: '/api/mercury/preferences/dictionary/groups',
            method: 'GET',
            parameter: false
        },
        notificationTypes: {
            api: '/api/mercury/preferences/dictionary/types',
            method: 'GET',
            parameter: false
        }


    }
};



// WEBPACK FOOTER //
// ./src/endpoints/ume.endpoints.ts